<template>
  <div class="upload-btn-div">
    <span class="upload-btn-container">
      <div class="pp">
        <img src="/images/photo-camera.png" alt />
      </div>
      <file-upload
        class="btn btn-primary"
        :post-action="s3Url"
        :accept="accepted"
        :extensions="extensions"
        :headers="headers"
        :size="1024 * 1024 * 10"
        :data="{
          role,
          module,
          created_for,
          certificate_type,
          remarks,
          deleteable,
          tentative_date,
          patient_name
        }"
        v-model="files"
        ref="upload"
        :input-id="refName"
        @input-file="inputFile"
        @input-filter="inputFilter"
        :multiple="multiple"
        :drop="drop"
        :disabled="disabled"
      >
        <span v-text="label" v-if="!drop"></span>
        <div v-if="drop && !uploadLoader" v-html="label"></div>
        <div v-else>
          <loader class="loadclass"></loader>
        </div>
      </file-upload>
    </span>
    <span class="badged-uploads" v-if="previousImage && previousImage.length > 0">
      <span class="badge primary">{{ previousImage.length }}</span>
      <a @click="imagePreviewPanel = true">view {{ previousImage.length == 1 ? "image" : "images" }}</a>
      <img @click="removeFile()" src="/images/error.png" />
    </span>
    <span class="badged-uploads" v-if="pdfSrc && pdfSrc.length">
      <span class="badge primary">{{ pdfSrc.length }}</span>
      <a @click="galleryModal = true">view {{ pdfSrc.length == 1 ? "pdf" : "pdfs" }}</a>
      <img @click="removeFile()" src="/images/error.png" />
    </span>
    <span class="badged-uploads" v-if="!uploadFileToServer && files && files.length > 0 ">
      <a > {{ files[0].name }}</a>
      <img @click="removeFile()" src="/images/error.png" />
    </span>
    <!-- <light-box :images="previousImage" ref="lightbox" :show-light-box="false"></light-box> -->

    <v-dialog v-model="galleryModal" width="900" content-class="v-dialog-lg">
      <v-card class="min-height" id="pharmacyCard">
        <nav
          class="v-toolbar theme--dark primary"
          data-booted="true"
          style="
            margin-top: 0px;
            padding-right: 0px;
            padding-left: 0px;
            transform: translateY(0px);
          "
        >
          <div class="v-toolbar__content" style="height: 40px">
            <div class="v-toolbar__title">PDF</div>
            <div class="spacer"></div>
            <button type="button" @click="galleryModal = false">
              <v-icon style="color: white">close</v-icon>
            </button>
          </div>
        </nav>
        <v-card-text style>
          <span @click="prePdf" v-if="pdfSrc[0] != currentPdf">
            <i class="fas fa-fast-backward"></i>
          </span>
          <span @click="currentPage = currentPage - 1" v-if="currentPage > 1">
            <i class="fas fa-backward"></i>
          </span>
          <!-- <pdf
            v-if="serverUrl"
            :src="currentPdf"
            @num-pages="pageCount = $event"
            :page="currentPage"
            @page-loaded="currentPage = $event"
            style="display: inline-block; width: 50%"
          ></pdf>-->
          <embed :src="currentPdf" width="100%" height="800px" />
          <span @click="currentPage = currentPage + 1" v-if="currentPage < pageCount">
            <i class="fas fa-forward"></i>
          </span>
          <span @click="nextPdf" v-if="pdfSrc && pdfSrc[pdfSrc.length - 1] != currentPdf">
            <i class="fas fa-fast-forward"></i>
          </span>
        </v-card-text>
        <v-card-actions>
          <div class="col-sm-12">
            <div class="row">
              <div class="col-sm-12 flex-end">
                <v-btn class="btn btn-red-outline" @click="galleryModal = false">Close</v-btn>
                <!-- <v-btn class="btn btn-primary" type="button">Save</v-btn> -->
              </div>
            </div>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <div class="ml-4 w-100" v-for="(image, i) in uploadedImg" :key="i">
      <span @click="$emit('showImage', image)" class="cursor">{{ image }}</span>
      <v-icon
        @click="removeImg()"
        class="close-icon"
        style="    font-size: 12px;
    float: right;
    background-color: gainsboro;
    border-radius: 50%;
    padding: 4px;"
      >mdi-window-close</v-icon>
    </div>

    <!-- <v-dialog v-model="imagePreviewPanel" width="680">
      <image-preview
        @update="updateImages"
        @delete="removeFile"
        :list="previousImage"
        @close="imagePreviewPanel = false"
      ></image-preview>
    </v-dialog>-->
    <!-- <span v-for="(file, id) in previousImage" :key="id"> -->
    <!-- <h1>In server</h1> -->
    <!-- <span class="txt-ellipp martop-2p">{{ file.name }}</span>
      <span>
        <img
          @click="removePreviousFile(index)"
          src="/images/error.png"
          style="width: 20px;margin: 7px;opacity: 0.6;cursor:pointer"
        />
      </span>
    </span>-->
  </div>
</template>

<style lang="scss" >
.example-simple label.btn {
  margin-bottom: 0;
  margin-right: 1rem;
}
.upload-btn-div {
  border: 1px solid #ccc !important;
  display: flex !important;
  position: relative !important;
  padding: 8px 5px !important;
  border-radius: 5px !important;
  align-items: center !important;
  height: 42px;
  right: 0;

  .upload-btn-container {
    height: unset !important;
  }

  .btn {
    background-color: gainsboro !important;
    color: gray !important;
    border-color: gainsboro !important;
    box-shadow: unset !important;
    padding: 3px 10px !important;
    height: auto;
  }

  .txt-ellipp {
    margin-top: 0 !important;
    margin-left: 10px !important;
  }

  img {
    // opacity: 0.6 !important;
    vertical-align: sub !important;
    margin: 0 !important;
  }

  .pp {
    position: absolute !important;
    min-width: 40px !important;
    right: 0 !important;
  }
}

.v-dialog {
  .txt-ellipp {
    width: calc(100% - 4.5vw);
  }

  .layout {
    .txt-ellipp {
      width: calc(100% - 7vw);
    }
  }
}

.full-txt {
  .txt-ellipp {
    width: calc(100% - 0vw) !important;
    float: unset !important;
  }
}
.close-icon:hover {
  color: red;
  cursor: pointer;
}
</style>

<script>
const loader = () => import("@/components/loader.vue");
import FileUpload from "vue-upload-component";
import config from "@/config.js";
import cloneDeep from "lodash/cloneDeep";
import { mapGetters, mapState } from "vuex";
// import LightBox from "vue-image-lightbox";
// import pdf from "vue-pdf";
// import ImagePreview from "./ImagePreview";
export default {
  props: [
    "deleteable",
    "media",
    "label",
    "multiple",
    "drop",
    "module",
    "created_for",
    "role",
    "refName",
    "uploadFileToServer",
    "src",
    "accept",
    "disabled",
    "certificate_type",
    "remarks",
    "tentative_date",
    "patient_name",
    "uploadedImg",
    "isBlogImage"
  ],
  components: {
    // LightBox,
    // pdf,
    FileUpload,
    loader
    // ImagePreview,
  },
  data() {
    return {
      imagePreviewPanel: false,
      galleryModal: false,
      currentPage: 1,
      pageCount: 0,
      pdfSrc: [],
      currentPdf: "",
      files: [],
      fileurl: "",
      showPreview: false,
      dialog: false,
      previousImage: [],
      extensions: "jpg,jpeg,png,webp,pdf", // (FOR PDF FILE) https://stackoverflow.com/questions/12142536/how-to-make-input-type-file-should-accept-only-pdf-and-xls/12142616
      accepted:
        this.accept ||
        "image/png,image/jpg,image/jpeg,image/webp,application/pdf",
      uploadLoader: false
    };
  },
  computed: {
    serverUrl() {
      if (this.currentPdf && this.currentPdf.includes(".pdf")) {
        return true;
      }
      return false;
    },
    s3Url() {
      if (this.isBlogImage) {
        return `${config.BASE_URL}api/v2/admin/public/blog/uploadFileS3`;
      }
      return `${config.BASE_URL}api/v2/admin/uploadFileS3`;
    },
    headers() {
      return {
        Authorization: `JWT ${this.$store.state.user.token}`
      };
    }
  },
  mounted() {
    if (this.src != undefined && this.src != "") {
      if (typeof this.src == "string") {
        if (
          this.src.includes(".pdf") ||
          (this.media && this.media.includes("pdf"))
        ) {
          this.pdfSrc = [this.src];
          this.currentPdf = this.src;
        } else {
          this.previousImage = [
            {
              src: this.src,
              thumb: this.src
            }
          ];
        }
      } else {
        this.previousImage = [];
        this.pdfSrc = [];

        this.src.map(img => {
          if (img.includes(".pdf")) {
            this.pdfSrc.push(img);
            if (!this.currentPdf) {
              this.currentPdf = img;
            }
          } else {
            let obj = {
              src: img,
              thumb: img
            };
            this.previousImage.push(obj);
          }
        });
      }
    } else {
      this.previousImage = [];
    }
  },
  watch: {
    uploadFileToServer: {
      handler(newValue) {
        this.uploadLoader = false;
        this.$refs.upload.active = newValue;
      },
      deep: true
    },
    src: {
      deep: true,
      handler(newValue) {
        this.resetUpload();
        if (newValue != undefined && newValue != "") {
          this.$emit("imageAdded", {});
          if (typeof this.src == "string") {
            if (
              this.src.includes(".pdf") ||
              (this.media && this.media.includes("pdf"))
            ) {
              this.pdfSrc = [this.src];
              this.currentPdf = this.src;
            } else {
              this.previousImage = [
                {
                  src: this.src,
                  thumb: this.src
                }
              ];
              this.pdfSrc = [];
            }
          } else {
            if (
              this.src.includes(".pdf") ||
              (this.media && this.media.includes("pdf"))
            ) {
              this.pdfSrc = this.src;
              this.currentPdf = this.src[0];
            } else {
              this.previousImage = [];
              this.pdfSrc = [];

              this.src.map(img => {
                if (img.includes(".pdf")) {
                  this.pdfSrc.push(img);
                  if (!this.currentPdf) {
                    this.currentPdf = img;
                  }
                } else {
                  let obj = {
                    src: img,
                    thumb: img
                  };
                  this.previousImage.push(obj);
                }
              });
            }
          }
        } else {
          this.previousImage = [];
        }
      }
    },
    accept: {
      handler(newValue) {
        this.accepted = "";
        this.$nextTick(() => {
          this.accepted = newValue;
        });
      }
    }
  },
  methods: {
    // updateImages(images, removedImage) {
    //   this.previousImage = images;
    //   let index = this.files.findIndex((item) => item.blob === removedImage);
    //   if (index > -1) {
    //     this.files.splice(index, 1);
    //   } else {
    //     this.$emit("removeImage", this.previousImage);
    //   }
    // },
    resetUpload() {
      this.previousImage = [];
      this.pdfSrc = [];
      this.currentPdf = "";
    },
    prePdf() {
      let index = this.pdfSrc.indexOf(this.currentPdf);
      this.currentPdf = this.pdfSrc[index - 1];
      this.currentPage = 1;
    },
    nextPdf() {
      let index = this.pdfSrc.indexOf(this.currentPdf);
      this.currentPdf = this.pdfSrc[index + 1];
      this.currentPage = 1;
    },
    removePreviousFile(index) {
      this.previousImage.splice(index, 1);
      this.$emit("uploaded", this.previousImage);
    },

    removeImg() {
      this.$emit("removeImage");
    },
    removeFile() {
      if(this.uploadFileToServer == false && this.files.length > 0){
        this.files =[];
        this.uploadLoader = false;
      }
    },
    removeImage(index) {
      let url = this.previousImage[index].src;
      url = url.split(
        `https://${config.S3_BUCKET}.s3.ap-south-1.amazonaws.com/`
      );
      if (url && url.length == 2) {
        // this.removeImagefromServer(url[1], index);
      }
    },
    removeImagefromServer(name, index) {
      let url = `${config.NEW_BASE_URL}api/s3DeleteFile/${name}`;
      this.$http.delete(url).then(response => {});
    },
    inputFilter(newFile, oldFile, prevent) {
      if(this.uploadFileToServer){
        this.uploadLoader = true;
      }
      if (newFile && !oldFile) {
        // Create the 'blob' field for thumbnail preview
        newFile.blob = "";
        let URL = window.URL || window.webkitURL;
        newFile.blob = URL.createObjectURL(newFile.file);
        // if (URL && URL.createObjectURL && newFile.type.includes("image")) {
        //   newFile.blob = URL.createObjectURL(newFile.file);
        // }
        this.$refs.upload.active = this.uploadFileToServer;
      }
    },
    // inputFile(newFile, oldFile) {
    //   if (typeof newFile != "undefined") {
    //     // doc https://github.com/lian-yue/vue-upload-component
    //     // this.$refs.upload.active = true;
    //     if (this.$refs.upload.uploaded) {
    //       let fileUrls = [];
    //       let fileName = [];
    //       this.files.map(function(file) {
    //         if (file.response.status) {
    //           //handling condition if we are setting image from DB
    //           fileUrls.push(file.response.file_url);
    //           fileName.push(file.response.data);
    //         } else {
    //           console.log("upload fail");
    //           //   this.$swal({
    //           //     text: "Upload failed",
    //           //     allowOutsideClick: false,
    //           //     showCancelButton: false,
    //           //     confirmButtonText: "Ok",
    //           //   });
    //         }
    //       });
    //       // After Files are Uploaded, return File URLs
    //       if (this.$refs.upload.uploaded)
    //         this.uploadLoader = false;
    //       this.$emit(
    //         "uploaded",
    //         fileUrls,
    //         this.$refs.upload.uploaded,
    //         fileName
    //       );
    //       this.$refs.upload.clear();
    //     } else {
    //       // When Files are Only selected and Not Uploaded
    //       if (this.$refs.upload.uploaded)
    //         this.uploadLoader = false;
    //       this.$emit("uploaded", this.files, this.$refs.upload.uploaded);
    //     }

    //     // if (newFile.response.status && newFile.success) {
    //     //   this.fileurl = newFile.response.file_url;
    //     // } else if (!newFile.response.status && newFile.success) {
    //     //   this.$emit("error", "File upload failed");
    //     // }
    //   }
    // },

    inputFile(newFile, oldFile) {
      if (typeof newFile != "undefined") {
        // doc https://github.com/lian-yue/vue-upload-component
        // this.$refs.upload.active = true;
        if (this.$refs.upload.uploaded) {
          let fileUrls = [];
          let fileName = [];
          let fileSize = this.files[0] && this.files[0]['size'] ? this.files[0]['size'] : 0
          let pdfFileName = this.files[0] && this.files[0]['name'] ? this.files[0]['name'] : ''
          this.files.map(function(file) {
            if (file.response.status) {
              //handling condition if we are setting image from DB
              fileUrls.push(file.response.file_url);
              fileName.push(file.response.data);
            }
          });
          // After Files are Uploaded, return File URLs
          if (this.$refs.upload.uploaded)
            this.uploadLoader = false;
          this.$emit(
            "uploaded",
            fileUrls,
            this.$refs.upload.uploaded,
            fileName,
            fileSize,
            pdfFileName
          );
          this.$refs.upload.clear();
        } else {
          // When Files are Only selected and Not Uploaded
          if (this.$refs.upload.uploaded)
            this.uploadLoader = false;
          this.$emit("uploaded", this.files, this.$refs.upload.uploaded);
        }
      }
    }
  }
};
</script>
